import React from "react";

const BlvdDirect = props => (
  <svg id="svg1" width={960} height={768} viewBox="0 0 960 768" {...props}>
    <defs id="defs1">
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath2">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-252.00001,-82.7998)"
          id="path2"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath4">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-468.00001,-504.00001)"
          id="path4"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath6">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-353.03681,-376.35971)"
          id="path6"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath8">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-488.96231,-357.67721)"
          id="path8"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath10">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-497.37471,-339.09671)"
          id="path10"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath12">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-502.73962,-320.51611)"
          id="path12"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath14">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-505.52032,-301.93551)"
          id="path14"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath16">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-506.00941,-283.35501)"
          id="path16"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath18">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-504.31451,-264.7744)"
          id="path18"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath20">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-500.17961,-246.1939)"
          id="path20"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath22">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-418.32801,-227.61331)"
          id="path22"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath24">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-483.00611,-209.0329)"
          id="path24"
        />
      </clipPath>
      <clipPath clipPathUnits="userSpaceOnUse" id="clipPath26">
        <path
          d="M 0,576 H 720 V 0 H 0 Z"
          transform="translate(-303.27781,-385.54801)"
          id="path26"
        />
      </clipPath>
    </defs>
    <g id="layer-MC0">
      <path
        id="path1"
        d="m 0,0 c -113.147,0 -205.2,92.053 -205.2,205.2 0,113.148 92.053,205.2 205.2,205.2 h 216 c 113.147,0 205.2,-92.052 205.2,-205.2 C 421.2,92.053 329.147,0 216,0 Z"
        style={{
          fill: "#003e53",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,336,657.60027)"
        clipPath="url(#clipPath2)"
      />
      <path
        id="path3"
        d="m 0,0 h -216 c -119.293,0 -216,-96.707 -216,-216 0,-119.293 96.707,-216 216,-216 H 0 c 119.293,0 216,96.707 216,216 C 216,-96.707 119.293,0 0,0 m 0,-21.6 c 51.926,0 100.744,-20.221 137.461,-56.939 36.718,-36.717 56.939,-85.535 56.939,-137.461 0,-51.926 -20.221,-100.744 -56.939,-137.461 C 100.744,-390.179 51.926,-410.4 0,-410.4 h -216 c -51.926,0 -100.744,20.221 -137.461,56.939 -36.718,36.717 -56.939,85.535 -56.939,137.461 0,51.926 20.221,100.744 56.939,137.461 36.717,36.718 85.535,56.939 137.461,56.939 z"
        style={{
          fill: "#003e53",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,624,96)"
        clipPath="url(#clipPath4)"
      />
      <path
        id="path5"
        d="m 0,0 c 14.389,0 27.473,-4.315 38.877,-9.393 h 91.48 c -2.094,3.193 -4.326,6.288 -6.682,9.292 z"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,470.71573,266.18707)"
        clipPath="url(#clipPath6)"
      />
      <path
        id="path7"
        d="m 0,0 h -81.286 c 3.695,-2.797 7.114,-5.9 10.231,-9.29 H 4.625 C 3.198,-6.126 1.654,-3.029 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,651.94973,291.09707)"
        clipPath="url(#clipPath8)"
      />
      <path
        id="path9"
        d="m 0,0 h -72.151 c 1.98,-2.948 3.778,-6.045 5.377,-9.29 H 3.025 C 2.12,-6.145 1.113,-3.044 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,663.16627,315.87107)"
        clipPath="url(#clipPath10)"
      />
      <path
        id="path11"
        d="m 0,0 h -68.239 c 1.058,-3.003 1.976,-6.099 2.725,-9.29 H 1.704 C 1.235,-6.154 0.661,-3.059 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,670.31947,340.6452)"
        clipPath="url(#clipPath12)"
      />
      <path
        id="path13"
        d="m 0,0 h -66.581 c 0.405,-3.029 0.674,-6.128 0.81,-9.29 H 0.519 C 0.442,-6.161 0.261,-3.066 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,674.02707,365.41933)"
        clipPath="url(#clipPath14)"
      />
      <path
        id="path15"
        d="m 0,0 h -66.244 c -0.111,-3.163 -0.357,-6.262 -0.736,-9.29 H -0.559 C -0.28,-6.224 -0.094,-3.127 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,674.6792,390.19333)"
        clipPath="url(#clipPath16)"
      />
      <path
        id="path17"
        d="m 0,0 h -66.905 c -0.725,-3.193 -1.617,-6.288 -2.652,-9.29 H -1.741 C -1.064,-6.233 -0.484,-3.134 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,672.41933,414.96747)"
        clipPath="url(#clipPath18)"
      />
      <path
        id="path19"
        d="m 0,0 h -69.271 c -1.577,-3.243 -3.344,-6.347 -5.306,-9.29 h 71.5 C -1.947,-6.244 -0.922,-3.147 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,666.90613,439.74147)"
        clipPath="url(#clipPath20)"
      />
      <path
        id="path21"
        d="m 0,0 c -3.116,-3.397 -6.544,-6.494 -10.247,-9.29 h 80.534 c 1.666,3.028 3.221,6.127 4.662,9.29 z"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,557.77067,464.5156)"
        clipPath="url(#clipPath22)"
      />
      <path
        id="path23"
        d="m 0,0 h -90.718 c -11.489,-5.088 -24.705,-9.393 -39.251,-9.393 L -6.702,-9.29 C -4.339,-6.288 -2.103,-3.191 0,0"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,644.00813,489.28947)"
        clipPath="url(#clipPath24)"
      />
      <path
        id="path25"
        d="m 0,0 h 165.449 c -3.055,3.243 -6.279,6.34 -9.661,9.29 H 0 v 9.291 h 143.914 c -4.83,3.373 -9.917,6.476 -15.241,9.29 H 0 v 9.29 h 107.197 c -17.399,6.014 -36.68,9.291 -57.438,9.291 H -62.56 -62.562 v -288 H 49.759 c 20.631,0 39.803,3.281 57.118,9.292 H 0 v 9.289 h 128.278 c 5.309,2.814 10.381,5.918 15.204,9.29 H 0 v 9.291 h 155.363 c 3.382,2.95 6.606,6.049 9.665,9.29 H 0 Z"
        style={{
          fill: "#5a960a",
          fillOpacity: 1,
          fillRule: "nonzero",
          stroke: "none"
        }}
        transform="matrix(1.3333333,0,0,-1.3333333,404.3704,253.936)"
        clipPath="url(#clipPath26)"
      />
    </g>
  </svg>
);
export default BlvdDirect;
